import { axiosInstance } from "@hopper-b2b/api";
import { startSessionPath } from "../paths";

export interface UberSessionInfo {
  hopperSessionToken: string;
  uberAccessToken: string;
  uberRefreshToken: string;
  userInfoResponse?: UberUserInfoResponse;
  csrfToken?: string;
  isFirstSession?: boolean;
  hopperUserId?: string;
  hopperUserIdToken?: string;
  kustomerAccessToken: string;
}

export interface UberUserInfoResponse {
  firstName?: string;
  lastName?: string;
  email?: string;
  mobileNumber?: string;
  riderId?: string;
}

export interface StartSessionResponse {
  hopperUserId: string;
  userInfoResponse: UberUserInfoResponse;
  hopperSessionToken: string;
  uberAccessToken: string;
  uberRefreshToken: string;
  hopperUserIdToken?: string;
  kustomerAccessToken: string;
}

export interface StartSessionRequest {
  idToken?: string;
  // @deprecated
  code?: string;
  initiator?: string;
}

export const startSession = ({
  code,
  idToken,
  initiator,
}: StartSessionRequest): Promise<StartSessionResponse> =>
  // eslint-disable-next-line no-async-promise-executor
  new Promise(async (resolve, reject) => {
    const reqBody = {
      code: code,
      idToken: idToken,
    };
    if (initiator) reqBody["initiator"] = initiator;
    try {
      const res = await axiosInstance.post(startSessionPath, reqBody);
      resolve(res.data);
    } catch (e) {
      reject(e);
    }
  });
export default startSession;
